import { SuggestedTopicPill } from "../../../Shared/SuggestedTopicPill/SuggestedTopicPill";
import { topicKeys } from "../automationKeys";
import { SharedTopicIcon } from "../SharedTopicIcon/SharedTopicIcon";
import * as SC from "../styles";
import { TopicIcon } from "../TopicIcon/TopicIcon";
import { TopicKeywords } from "../TopicKeywords/TopicKeywords";
import { TopicName } from "../TopicName/TopicName";

type MetadataTitleSchema = {
    isLoading: boolean;
    name: string;
    topicName: string;
    isSuggestion: boolean;
    isShared: boolean;
    sharedBy: string;
    keywordsCount: number | string;
};

export const MetadataTitle = ({
    isLoading,
    name,
    topicName,
    isSuggestion,
    isShared,
    sharedBy,
    keywordsCount,
}: MetadataTitleSchema) => {
    return (
        <SC.StyledTopicMetaData data-automation={topicKeys.metaContainer}>
            <TopicIcon isLoading={isLoading} />

            <SC.StyledColumn>
                <SC.StyledTopicGroup>
                    <TopicName
                        name={name || topicName}
                        isLoading={isLoading}
                    />

                    {isSuggestion && !isLoading ? <SuggestedTopicPill /> : null}
                    {isShared && !isLoading ? <SharedTopicIcon ownerName={sharedBy} /> : null}
                </SC.StyledTopicGroup>

                <TopicKeywords
                    isLoading={isLoading}
                    keywordsCount={keywordsCount}
                />
            </SC.StyledColumn>
        </SC.StyledTopicMetaData>
    );
};
